module.exports = __webpack_public_path__ + "static/img/news2-m@2x.4d365466.png";